import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Injectable, Component, Input, NgModule, defineInjectable } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fortawesome/angular-fontawesome';
class NgxWhastappButtonService {
    constructor() { }
}
NgxWhastappButtonService.ɵfac = function NgxWhastappButtonService_Factory(t) { return new (t || NgxWhastappButtonService)(); };
NgxWhastappButtonService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgxWhastappButtonService, factory: NgxWhastappButtonService.ɵfac, providedIn: 'root' });
NgxWhastappButtonService.ctorParameters = () => [];
/** @nocollapse */ NgxWhastappButtonService.ngInjectableDef = defineInjectable({ factory: function NgxWhastappButtonService_Factory() { return new NgxWhastappButtonService(); }, token: NgxWhastappButtonService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxWhastappButtonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxWhastappButtonComponent {
    constructor() {
        this.ngx_whatsapp_url = 'https://api.whatsapp.com/send';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // we set the icon
        this.ngx_whatsapp_icon = faWhatsapp;
        //verify if we had a number
        this.ngx_whatsapp_phone = (this.ngx_whatsapp_phone !== undefined) ? this.ngx_whatsapp_phone : '';
        this.ngx_whatsapp_text = (this.ngx_whatsapp_text !== undefined) ? this.ngx_whatsapp_text : '';
        this.ngx_whatsapp_url = `${this.ngx_whatsapp_url}?phone=${this.ngx_whatsapp_phone}&text=${this.ngx_whatsapp_text}`;
    }
}
NgxWhastappButtonComponent.ɵfac = function NgxWhastappButtonComponent_Factory(t) { return new (t || NgxWhastappButtonComponent)(); };
NgxWhastappButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxWhastappButtonComponent, selectors: [["jjva-ngx-whatsapp-button"]], inputs: { ngx_whatsapp_phone: "ngx_whatsapp_phone", ngx_whatsapp_text: "ngx_whatsapp_text" }, decls: 3, vars: 2, consts: [["target", "_blank", 1, "ngx-whatsapp-button-float", 3, "href"], [2, "margin-top", "20%"], [1, "fa-2x", "ngx-whatsapp-button-my-float", 3, "icon"]], template: function NgxWhastappButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "fa-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("href", ctx.ngx_whatsapp_url, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("icon", ctx.ngx_whatsapp_icon);
    } }, directives: [ɵngcc1.FaIconComponent], styles: [".ngx-whatsapp-button-float[_ngcontent-%COMP%]{position:fixed;width:60px;height:60px;bottom:40px;right:40px;background-color:#25d366;color:#fff;border-radius:50px;text-align:center;box-shadow:2px 2px 3px #999}.ngx-whatsapp-button-my-float[_ngcontent-%COMP%]{margin-top:22px}"] });
NgxWhastappButtonComponent.ctorParameters = () => [];
NgxWhastappButtonComponent.propDecorators = {
    ngx_whatsapp_phone: [{ type: Input, args: ['ngx_whatsapp_phone',] }],
    ngx_whatsapp_text: [{ type: Input, args: ['ngx_whatsapp_text',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxWhastappButtonComponent, [{
        type: Component,
        args: [{
                selector: 'jjva-ngx-whatsapp-button',
                template: "<a target=\"_blank\" [href]=\"ngx_whatsapp_url\" class=\"ngx-whatsapp-button-float\">\n     <div style=\"margin-top:20%;\"><fa-icon class=\" fa-2x ngx-whatsapp-button-my-float\"  [icon]=\"ngx_whatsapp_icon\"></fa-icon></div>\n</a>\n",
                styles: [".ngx-whatsapp-button-float{position:fixed;width:60px;height:60px;bottom:40px;right:40px;background-color:#25d366;color:#fff;border-radius:50px;text-align:center;box-shadow:2px 2px 3px #999}.ngx-whatsapp-button-my-float{margin-top:22px}"]
            }]
    }], function () { return []; }, { ngx_whatsapp_phone: [{
            type: Input,
            args: ['ngx_whatsapp_phone']
        }], ngx_whatsapp_text: [{
            type: Input,
            args: ['ngx_whatsapp_text']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxWhastappButtonModule {
}
NgxWhastappButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxWhastappButtonModule });
NgxWhastappButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxWhastappButtonModule_Factory(t) { return new (t || NgxWhastappButtonModule)(); }, imports: [[
            FontAwesomeModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxWhastappButtonModule, { declarations: function () { return [NgxWhastappButtonComponent]; }, imports: function () { return [FontAwesomeModule]; }, exports: function () { return [NgxWhastappButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxWhastappButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FontAwesomeModule
                ],
                declarations: [NgxWhastappButtonComponent],
                exports: [NgxWhastappButtonComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxWhastappButtonService, NgxWhastappButtonComponent, NgxWhastappButtonModule };

//# sourceMappingURL=ngx-whatsapp-button.js.map